import InputCode from './InputCode';

export default InputCode;
